import angular from 'angular';
import { searchBarComponent } from './searchBarComponent';

angular.module('sh.searchBar', []).component('shSearchBar', searchBarComponent()); // <sh-search-bar>
